export default __webpack_public_path__ + "static/media/kitchen4-afterC-1024w.b26e1b15.png";